// The canonical origin used to build every auth redirect_to. It MUST match the
// Supabase redirect allow list exactly — a www / preview / trailing-slash
// origin gets rejected and falls back to the project Site URL, which dumps the
// auth ?code= on the bare homepage (the "links just open the home page" bug).
//
// So we normalize hard: strip any trailing slash, and collapse www → apex.
//
// LEGACY GUARD — the product was renamed pur0 → innernet (2026-05-26), but a
// stale NEXT_PUBLIC_SITE_URL can outlive a rename in the deploy env. Any origin
// still pointing at the old domain is treated as unset, so minted links can
// never say pur0 again regardless of environment drift.

const LEGACY_HOST = /(^|\.)pur0\.run$/i;

const FALLBACK = 'https://innernet.live'

function normalize(origin: string): string {
  return origin.replace(/\/+$/, '').replace('://www.', '://')
}

function usable(origin: string | null | undefined): origin is string {
  if (!origin) return false
  try {
    return !LEGACY_HOST.test(new URL(origin).hostname)
  } catch {
    return false
  }
}

export function siteUrl(): string {
  const env = process.env.NEXT_PUBLIC_SITE_URL
  if (usable(env)) return normalize(env)
  if (typeof window !== 'undefined' && usable(window.location.origin)) {
    return normalize(window.location.origin)
  }
  return FALLBACK
}

/** The origin the caller is ACTUALLY on, derived from the request headers —
 *  for links minted by API routes (invites, shares). Always matches the domain
 *  in the address bar (production, preview, localhost alike), so it can never
 *  drift the way an env var can. Falls back to siteUrl(). */
export function requestOrigin(headers: Headers): string {
  const host = headers.get('x-forwarded-host') ?? headers.get('host')
  if (host && !LEGACY_HOST.test(host.split(':')[0])) {
    const proto = headers.get('x-forwarded-proto') ?? (host.startsWith('localhost') || host.startsWith('127.') ? 'http' : 'https')
    return normalize(`${proto.split(',')[0].trim()}://${host}`)
  }
  return siteUrl()
}
